import { Divider, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import WSTextField, { TextType } from "../../../Components/TextBox/WSTextBox";
import WSButton from "../../../Components/Button/WSButton";
import { callAPI, clearRequest, Method } from "../../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { useNavigate, useParams } from "react-router-dom";
import WSFileUpload from "../../../Components/FileUpload/WSFileUpload";
import { Header } from "../../../Components/Header/Header";
import WSHiddenField from "../../../Components/HiddenField/WSHiddenField";
import WSDateField from "../../../Components/DateField/WSDateField";
import dayjs from "dayjs";
export const BannerImage: React.FC<any> = React.memo((props) => {
  const { control, register, handleSubmit, setValue, reset } = useForm();
  const { showMessage } = useSnackbar();
  const params = useParams();
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const id = params?.id;
  const [defaultImg, setDefaultImg] = useState<any | null>(null);
  const [startDate, setStartDate] = useState<string>()
  const navigate = useNavigate();
  useEffect(() => {
    /**
     * Edit Function
     * @param id
     *
     */
    async function getBannerById(id: any) {
      try {
        const response: any = await callAPI(`BannerImage`, Method.GET, {}, id);
        console.log("response", response);

        if (response && response?.data) {
          setValue("startDate", dayjs(response.data?.startDate).format('DD/MM/YYYY'));
          setValue("displayOrder", response.data?.displayOrder);
          setValue("endDate", dayjs(response.data?.endDate).format('DD/MM/YYYY'));
          setDefaultImg(response.data.imgurl)
          setValue("id", response.data?.id);
        }
      } catch (error) {
        console.log("failed to retrieve data", error);
      }
    }
    if (id) {
      getBannerById(id);
    }
  }, [id, setValue]);

  /**
   * Method for Add the data
   * @param data
   */
  const handleData = async (data: any) => {
    try {
      console.log("Submitted data:", data);
      // Extract image name from the uploaded file.
      let imageName = "";
      if (data.imageUrl && data.imageUrl[0]) {
        const file = data.imageUrl[0]; // Assuming `imageUrl` contains an array of files.
        imageName = file.name; // Get the file name from the uploaded image.
      }

      const startDate = dayjs(data.startDate, "DD/MM/YYYY").format('YYYY-MM-DDTHH:mm:ss.SSS')
      const endDate = dayjs(data.endDate, "DD/MM/YYYY").format('YYYY-MM-DDTHH:mm:ss.SSS')
      const formData = new FormData()
      formData.append("file", selectedFile!);
      formData.append("imgUrl", data.imgUrl); // Add title
      formData.append("displayOrder", data.displayOrder); // Add display
      formData.append("startDate", startDate);
      formData.append("endDate", endDate);

      if (id) {
        formData.append("id", id); // Add display
        const response: any = await callAPI(`BannerImage/${id}`, Method.PUTFORMDATA, null, null, formData);
        if (response) {
          showMessage(response?.message, response.success === true ? "success" : "error");
          response.success === true && navigate("/banner/list");
        }
      } else {
        const response: any = await callAPI("BannerImage/Create", Method.POSTFORMDATA, null, null, formData);
        if (response) {
          showMessage(response?.message, response.success === true ? "success" : "error");
          response.success === true && navigate("/banner/list");
        }
      }
    } catch (e: any) {
      showMessage(e.error);
    }
  };

  const handleUploadFile = (file: any) => {
    setDefaultImg(null)
    if (file && file.length > 0) {
      setSelectedFile(file[0]);
    }
  }
  const handleRemove = (id: string) => {
    alert(id)
  }
  const handleStartDateChange = (evt: any) => {
    setStartDate(evt)
  }
  const handleCancelClick = () => {
    navigate('/banner/list')
  }
  return (
    <>
      <Header type="simple" isDivider={true} title={`${id ? 'Edit' : 'Add'} BannerImage`} url="/banner/list" id={'bannerimageImg'} isBackButton={true} headerSx={{ marginTop: 0, }} />
      <form onSubmit={handleSubmit(handleData)}>
        <Grid
          sx={{
            padding: 4,
            backgroundColor: "#fff",
            borderRadius: 2,
            border: "1px solid lightgrey",
            marginTop: 0,
          }}
        >
          <Grid item container spacing={2}>
            <Grid item xs={12} sm={4}>
              <WSDateField
                id="startDate"
                name="startDate"
                label={"Start Date"}
                dateFormat="DD/MM/YYYY"
                denyFuturOrPast="past"
                onChange={handleStartDateChange}
                control={control}
                defaultValue={null}
                rules={{ required: true }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <WSDateField
                id="endDate"
                name="endDate"
                label={"End Date"}
                dateFormat="DD/MM/YYYY"
                denyFuturOrPast="custom"
                control={control}
                defaultValue={startDate}
                setValue={setValue}
                rules={{ required: true }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <WSTextField
                label={"Display Order"}
                {...register("displayOrder")}
                id="displayOrder"
                name="displayOrder"
                type={TextType.Number}
                control={control}
                rules={{ required: true }}
              // labelType="Normal"
              />
            </Grid>


            <Grid item sm={6} style={{ overflow: 'auto' }}>
              <WSFileUpload
                name="imageUrl"
                label="Banner Image"
                control={control}
                rules={{ required: defaultImg ? false : true }}
                acceptFileTypes=".jpg,.jpeg,.png"
                maxFileSizeMB={2}
                defaultValue={defaultImg}
                id={"imageUrl"}
                image={true}
                onChange={handleUploadFile}
                onRemove={handleRemove}
                align="Start"
                isToolTipImg={false}
                multiple={false}
              />
            </Grid>
            <Grid item xs={12} sm={6} style={{ display: "none" }}>
              <WSHiddenField
                name="id"
                control={control}

              />
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                marginTop: "3rem",
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
              }}
            >
              <WSButton
                id="submit"
                label={"Save"}
                type="submit"
                size="medium"
              />
              <WSButton
                id="cancel"
                label={"Cancel"}
                type="button"
                size="medium"
                className="ws-cancel"
                onClick={handleCancelClick}
              />
            </Grid>
          </Grid>
        </Grid>
      </form>

    </>);
});
